const type = {
    pageFetch: {
        name: 'PageFetch',
        message: (url: string) => `Prefetch of page "${url}" failed`,
    },
};

export default type;
